<template>
<!-- 行程海报图样式 -->
  <div
    id="xingchengPic"
    class="xingchengPic"
    v-bind:style="{backgroundImage:'url(' +'\''+ backgroundPic +'\''+ ')', backgroundRepeat:'no-repeat'}"
    v-loading="loading"
  >
  <div class="xingchengContent white" v-html="dayContent">
  </div>

  </div>
</template>

<script>
export default {
  name: "xingchengPic",
  data() {
    return {
      loading: false
    };
  },
  props: ["dayContent","backgroundPic"],
  methods: {
  },

  computed: {
  },
  mounted() {
    
  }
};
</script>

<style scoped>
#xingchengPic {
  width: 100%;
  height: 100%;
  /* background: url("../../../static/images/banner02.jpg") no-repeat; */
  background-position: center;
  background-size: cover;
  position: relative;
}

.xingchengContent{
  position: absolute;
  display: flex;
  justify-content: space-around;
  top: 440px;
  margin: 0 10%;
  width: 80%;
  font-size: 29px;
  font-weight: bold;
  text-align: center;
}

.white{
  color: #fff;
}


</style>



// WEBPACK FOOTER //
// src/components/comment/tbChildPage/xingchengPic.vue